import { Stack } from '@mui/material';
import { ChangePassword } from 'components/settings/ChangePassword';
import { DeleteUser } from 'components/settings/DeleteUser';
import { Source } from 'dtos/users/common';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'stores/RootStore';

const Account = observer(() => {
  const { changePasswordStore, deleteUserStore, authStore } = useRootStore();
  const { currentUser } = authStore;

  return (
    <div aria-label="account settings page" style={{ width: 400, marginTop: 60, marginBottom: 30 }}>
      <Stack spacing={8}>
        {currentUser?.source === Source.LOCAL && <ChangePassword changePasswordStore={changePasswordStore} />}
        <DeleteUser deleteUserStore={deleteUserStore} />
      </Stack>
    </div>
  );
});

export { Account };
